import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

import { ContainerSection } from '@components/_global/GlobalStyle/Global.styled';

import { breakpoints } from '@shared/constants';

export const StyledTitle = styled(Typography.TextH3_24_34)`
    margin-bottom: 30px;
    text-align: center;
`;

export const StyledText = styled(Typography.TextBody_16_24)`
    margin-bottom: 24px;
    max-width: 350px;
    text-align: center;
`;

export const StyledContainerSection = styled(ContainerSection)`
    margin: 0 auto;
    max-width: 460px;
    width: 100%;
`;

export const ErrorCard = styled.div(
    ({ theme: { boxShadow, palette, radius } }) => css`
        align-items: center;
        background-color: ${palette.neutral.white};
        border-radius: ${radius[4]}px;
        box-shadow: ${boxShadow.small};
        display: flex;
        flex-direction: column;
        margin-top: 25px;
        padding: 35px 55px 80px 55px;

        @media (max-width: ${breakpoints.md}px) {
            margin-top: 0;
            padding: 40px 15px;
        }
    `,
);

export const ErrorText = styled.h1(
    ({ theme: { font, fontWeight, palette } }) => css`
        color: ${palette.text.assistive};
        font-family: ${font.primary};
        font-size: 122px;
        font-weight: ${fontWeight.normal};
        letter-spacing: 0.03em;
        line-height: 176px;
        margin: 0 0 20px;
        position: relative;
        z-index: 1;

        &:after {
            background-color: ${palette.neutral.gray};
            border-radius: 100%;
            bottom: 36px;
            content: '';
            height: 16px;
            left: 0;
            position: absolute;
            width: 237px;
            z-index: -1;
        }
    `,
);

export const ErrorImage = styled.img`
    margin: 20px 0 50px;
`;

export const StyledImage = styled.img`
    bottom: 0;
    position: absolute;
    right: -312px;

    @media (max-width: ${breakpoints.md}px) {
        display: none;
    }
`;
